import creditCard from './creditCard';
import subscription from './subscription';

export default {
  ...subscription,
  ...creditCard,
};
